import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import PhotoGalleryService from "../../../_services/PhotoGalleryService";

interface Album {
  id: number;
  name: string;
  description: string | null;
  eventDate: string | null;
}

interface Props {
  show: boolean;
  album: Album | null;
  onHide: () => void;
  onSaved: () => void;
}

const AlbumForm: React.FC<Props> = ({ show, album, onHide, onSaved }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setName(album?.name || "");
      setDescription(album?.description || "");
      setEventDate(album?.eventDate?.slice(0, 10) || "");
    }
  }, [show, album]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;

    setSaving(true);
    try {
      const body = {
        name: name.trim(),
        description: description.trim() || undefined,
        eventDate: eventDate || undefined,
      };

      if (album) {
        await PhotoGalleryService.updateAlbum(album.id, body);
      } else {
        await PhotoGalleryService.createAlbum(body);
      }
      onSaved();
    } catch (err) {
      console.error("Failed to save album", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{album ? "Edit Album" : "Create Album"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Album Name *</Form.Label>
            <Form.Control
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Annual Day 2026"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Optional description"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Event Date</Form.Label>
            <Form.Control
              type="date"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? "Saving..." : album ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AlbumForm;
